export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M1.858 10.473l8.485-8.485a1 1 0 011.477.07l6.324 7.634 2.166-1.036a1 1 0 011.139.195l3.743 3.744a1 1 0 010 1.414l-4.95 4.95 7.541 7.54a1 1 0 01-1.414 1.414l-7.54-7.54-4.95 4.95a1 1 0 01-1.415 0l-3.743-3.744a1 1 0 01-.195-1.139l1.036-2.166-7.635-6.324a1 1 0 01-.07-1.477zM17.1 11.57l-6.12-7.39-6.932 6.932 7.39 6.12a1 1 0 01.264 1.202l-1.068 2.232 2.536 2.536 9.9-9.9-2.536-2.536-2.232 1.068a1 1 0 01-1.202-.264z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "32",
    "height": "33",
    "fill": "currentColor",
    "viewBox": "0 0 32 33"
  }
};